import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('nav_1'), id: '#amazon-sale-D', key: 0 },
        { text: t('nav_2'), id: '#amazon-sale-E', key: 1 },
        { text: t('nav_3'), id: '#amazon-sale-F', key: 2 },
    ];

    const handleClickTab = (k: number) => setActiveTab(k);

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        const targetD = document.querySelector('#amazon-sale-D') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#amazon-sale-D',
            triggerHook: 1,
            offset: '50%',
            duration: targetD?.offsetHeight,
            onEnter: () => setActiveTab(0),
        });

        const targetE = document.querySelector('#amazon-sale-E') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#amazon-sale-E',
            triggerHook: 1,
            offset: '50%',
            duration: targetE?.offsetHeight,
            onEnter: () => setActiveTab(1),
        });

        const targetF = document.querySelector('#amazon-sale-F') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#amazon-sale-F',
            triggerHook: 1,
            offset: '50%',
            duration: targetF?.offsetHeight,
            onEnter: () => setActiveTab(2),
        });

        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            }
        }, 3000);
    }, []);

    return (
        <div className={`amazon-sale-fix-tab ${css['amazon-sale-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
